export const allowedRedirectPaths = [
  '/dashboard/profile',
  '/dashboard/family',
  '/dashboard/family/create',
  '/dashboard/security',
  '/dashboard/privacy',
  '/dashboard/places',
  '/dashboard/services',
  '/dashboard/devices'
]
